/**
 * Честный вход на CSGOPositive: страницы матча нет, человек ищет строку.
 *
 * `event_url` остаётся корнем без path — иначе `direct` выключит unverifiable.
 * Подпись и id (`data-id`) говорят, что искать на главной.
 */

export function opponentOf(name: string, who: readonly string[]): string {
  return who.find((one) => one !== name) ?? who[1] ?? who[0] ?? '';
}

export function positiveFindLine(
  name: string,
  opponent: string,
  eid?: string | null,
): string {
  const pair = opponent && opponent !== name ? `${name} / ${opponent}` : name;
  const id = eid ? ` · id ${eid}` : '';
  return `главная Positive — найди строку ${pair}${id}`;
}
